import React from 'react';
import Link from 'components/link';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import { useThemeContext } from 'contexts/theme';
import { ThemeNames } from 'types/themes';
import { sanitizeTestid } from 'utils/stringSanitization';

interface Props {
  className: string;
  keyword: {
    link: string;
    label: string;
  };
}

export default function Keyword({ keyword: { link, label }}: Props) {
  const { themeName } = useThemeContext();
  const isExpTheme = themeName !== ThemeNames.ZOOCASA;

  return (
    <Link
      href={link}
      target={isExpTheme ? '_blank' : ''}
      testId={sanitizeTestid(label)}
      className={buildClassName(styles.component, isExpTheme ? styles['exp-keyword'] : styles['zoocasa-keyword'])}>
      {label}
    </Link>
  );
}
